import $ from 'jquery';
import FormUploadTemplate from './FormUpload.mustache';
import config from '../config.mjs';

const $inputFileUploads = $('.form-control-file');

$inputFileUploads.each((index, inputFileUpload) => {
  const $inputFileUpload = $(inputFileUpload);
  const $formGroup = $inputFileUpload.closest('.form-group');
  const $formUploadHolder = $formGroup.nextAll('.form-input-image-upload-holder');

  $inputFileUpload.on('change', (event) => {
    if (event.currentTarget.files.length !== 1) {
      return;
    }

    const $formUploadGroup = $formGroup.nextAll('.form-group-upload');
    _removeOldFormUpload($formUploadGroup);

    _removeFormError($inputFileUpload);

    const file = event.currentTarget.files[0];
    _addFormUpload($formUploadHolder, file);
  });
});

/**
 * @param {jQuery} $formUploadGroup .form-group-upload
 */
function _removeOldFormUpload($formUploadGroup) {
  $formUploadGroup.remove();
}

/**
 * @param {jQuery} $inputFileUpload
 */
function _removeFormError($inputFileUpload) {
  $inputFileUpload.parent().removeClass('has-error');
}

/**
 * @param {jQuery} $formUploadHolder
 * @param {File} file
 */
function _addFormUpload($formUploadHolder, file) {
  const renderedHtml = FormUploadTemplate.render({
    'shopConfig': config,
    'formUpload': {
      'fileName': file.name,
    },
  });

  $formUploadHolder.html(renderedHtml);
}
